import { shortEllipsis } from "./utility-methods";


export const carouselData = [
    {
        image: "/images/graduands.jpg",
        caption: 'We facilitate your admission and travel to study the course of your dreams in reputable foreign universities'
    },
    {
        image: "/images/school-travel.jpg",
        caption: 'We are partners with local higher education institutions, whose students we help go for short courses or refresher courses overseas'
    },
    {
        image: "/images/study-banner.jpg",
        caption: 'Realize your study visa dreams with us'
    }
]


export const lorem = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio asperiores, minus ipsam ducimus eum tempore dolore soluta necessitatibus assumenda provident itaque obcaecati modi beatae autem molestias vitae tenetur quisquam fugit?";

export const europe =[
    {
        country: "Austria",
        flag: "/images/europe/austria.png"
    },
    {
        country: "Belgium",
        flag: "/images/europe/belgium.png"
    },
    {
        country: "Cyprus",
        flag: "/images/europe/cyprus.png"
    },
    {
        country: "DenMark",
        flag: "/images/europe/denmark.png"
    },
    {
        country: "Finland",
        flag: "/images/europe/finland.png"
    },
    {
        country: "France",
        flag: "/images/fr.jpg"
    },
    {
        country: "Great Britain",
        flag: "/images/gb.jpg"
    },
    {
        country: "Germany",
        flag: "/images/europe/germany.png"
    },
    {
        country: "Greece",
        flag: "/images/europe/greece.png"
    },
    {
        country: "Italy",
        flag: "/images/europe/italy.png"
    },
    {
        country: "Malta",
        flag: "/images/europe/Malta.png"
    },
    {
        country: "Poland",
        flag: "/images/europe/poland.png"
    },
    {
        country: "Russia",
        flag: "/images/europe/russia.png"
    },
    {
        country: "Spain",
        flag: "/images/europe/spain.png"
    },
    {
        country: "Sweden",
        flag: "/images/europe/sweden.png"
    },
    {
        country: "Turkey",
        flag: "/images/europe/turkey.png"
    }
]


export const asia = [
    {
        country: "China",
        flag: "/images/asia/china.webp"
    },
    {
        country: "India",
        flag: "/images/asia/india.png"
    },
    {
        country: "Indonesia",
        flag: "/images/asia/indonesia.png"
    },
    {
        country: "North Korea",
        flag: "/images/asia/north-korea.png"
    },
    {
        country: "Malaysia",
        flag: "/images/asia/malaysia.png"
    },
    {
        country: "Pakistan",
        flag: "/images/asia/pakistan.jpg"
    },
   
    {
        country: "South Korea",
        flag: "/images/asia/south-korea.png"
    },
    {
        country: "Thailand",
        flag: "/images/asia/thailand.png"
    },
    {
        country: "Vietnam",
        flag: "/images/asia/vietnam.webp"
    },
    {
        country: "Singapore",
        flag: "/images/asia/singapore.png"
    },
    {
        country: "Japan",
        flag: "/images/asia/japan.png"
    }
]

export const africa = [
    {
        country: "Egypt",
        flag: "/images/africa/egypt.png"
    },
    {
        country: "Ghana",
        flag: "/images/africa/ghana.png"
    },
    {
        country: "Ivory Coast",
        flag: "/images/africa/ivory-coast.png"
    },
    {
        country: "Moroco",
        flag: "/images/africa/moroco.png"
    },
    {
        country: "Rwanda",
        flag: "/images/africa/rwanda.png"
    },
    {
        country: "Senegal",
        flag: "/images/africa/senegal.png"
    },
    {
        country: "South Africa",
        flag: "/images/africa/south-africa.png"
    },
    {
        country: "Tunisia",
        flag: "/images/africa/tunisia.png"
    },
]

export const america = [
    {
        country: "Argentina",
        flag: "/images/america/argentina.png"
    },
    {
        country: "Canada",
        flag: "/images/america/canada.png"
    },
    {
        country: "Hawaii",
        flag: "/images/america/hawaii.png"
    },
    {
        country: "Jamaica",
        flag: "/images/america/jamaica.png"
    },
    {
        country: "Mexico",
        flag: "/images/america/mexico.png"
    },
    {
        country: "Trinidad and Tobago",
        flag: "/images/america/trinidad-tobago.png"
    },
]

export const newsItems = [
    {
        title: shortEllipsis("Study abroad: chasing dreams far away, embracing the wonderful picture of the world"),
        image: "/images/holding-globe.jpg",
        category: "IMMIGRATION",
        color: "#07903d",
        uri: "/blog?id=blog2"

    },
    {
        title: "Esential documents for a successful Visa application...",
        image: "/images/houston-lawyer.jpg",
        category: "IMMIGRATION",
        color: "#dc5b0b",
        uri: "/blog?id=blog1"

    },
    {
        title: shortEllipsis("Study Abroad Time Difference: Challenges and Adaptations Across Time and Space"),
        image: "/images/clock.jpg",
        category: "CONSULTING",
        color: "#166cc3",
        uri: "/blog?id=blog1"
    }

]

export const visaData = [
    "Student Visa",
    "Resident Visa",
    "Working Visa",
    "Commercial Visa",
    "Tourist Visa"
];

